import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelCheckbox as _vModelCheckbox, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, withKeys as _withKeys } from "vue"

const _hoisted_1 = { class: "login" }
const _hoisted_2 = {
  class: "form",
  novalidate: ""
}
const _hoisted_3 = ["disabled"]
const _hoisted_4 = { class: "form-items cf" }
const _hoisted_5 = {
  key: 0,
  class: "item"
}
const _hoisted_6 = { class: "control" }
const _hoisted_7 = {
  class: "label",
  for: "UserName"
}
const _hoisted_8 = { class: "item" }
const _hoisted_9 = { class: "control" }
const _hoisted_10 = {
  class: "label",
  for: "Email"
}
const _hoisted_11 = { class: "item" }
const _hoisted_12 = {
  class: "control",
  "data-type": "password"
}
const _hoisted_13 = {
  class: "label",
  for: "Password"
}
const _hoisted_14 = {
  key: 0,
  class: "icon fastic-eye-show"
}
const _hoisted_15 = {
  key: 1,
  class: "icon fastic-eye-hide"
}
const _hoisted_16 = {
  key: 1,
  class: "item"
}
const _hoisted_17 = {
  class: "control",
  "data-type": "password"
}
const _hoisted_18 = {
  class: "label",
  for: "ConfirmPassword"
}
const _hoisted_19 = {
  key: 0,
  class: "icon fastic-eye-show"
}
const _hoisted_20 = {
  key: 1,
  class: "icon fastic-eye-hide"
}
const _hoisted_21 = ["disabled"]
const _hoisted_22 = {
  class: "form-items",
  "data-type": "privacy"
}
const _hoisted_23 = { class: "item" }
const _hoisted_24 = { class: "checkbox" }
const _hoisted_25 = { for: "IsPrivacyPolicy" }
const _hoisted_26 = { class: "disclaimer" }
const _hoisted_27 = ["href"]
const _hoisted_28 = ["disabled"]
const _hoisted_29 = {
  key: 0,
  class: "validation-summary-errors"
}
const _hoisted_30 = {
  class: "form-items",
  "data-type": "buttons"
}
const _hoisted_31 = { class: "item calltoaction" }
const _hoisted_32 = ["disabled"]
const _hoisted_33 = { class: "lable" }
const _hoisted_34 = { class: "item" }
const _hoisted_35 = ["innerHTML"]

import { ref, onBeforeMount } from "vue";
import Axios from "axios";
import FormHelper from "@Scripts/Common/FormHelper";
import Localizer from "@Scripts/Common/Localizer";
import GTagHelper from "@Scripts/Infrastructure/GTagHelper";


export default /*@__PURE__*/_defineComponent({
  __name: 'AccountRegister',
  props: {
    recaptchaSiteKey: {},
    returnUrl: {}
  },
  setup(__props: any) {

const props = __props;

const formHelper = FormHelper;
const localizer = Localizer;
const routes = (window as any).App.routes;

const isLoading = ref(false);
const isSuccess = ref(false);
const openPrivacy = ref(false);
const formData = ref<any>({});
const validationErrors = ref<any[]>([]);
const options = ref<any>(null);
const isHidden = ref(true);
const isHiddenCheck = ref(true);

onBeforeMount(async () => {
    options.value = (await Axios.post(routes.Account_GetOptions, null, { headers: { "RequestVerificationToken": FormHelper.getRequestVerificationToken() } })).data;
});

async function submitForm() {
    FormHelper.removeFocus();

    validationErrors.value = [];

    isLoading.value = true;

    formData.value.redirectUrl = props.returnUrl;

    (window as any).grecaptcha.enterprise.ready(async () => {
        const token = await (window as any).grecaptcha.enterprise.execute(props.recaptchaSiteKey, { action: 'Submit' });
        try {
            const response = await Axios.post(routes.Account_Register, formData.value, { headers: { "RecaptchaVerificationToken": token } });

            isSuccess.value = true;

            GTagHelper.sendEvent("form_submit", "account_login");

            window.location.href = response.data.redirectUrl ? response.data.redirectUrl : routes.Home_Home;
        } catch (error: any) {
            if (error.response && error.response.status === 400) {
                validationErrors.value = FormHelper.getValidationErrors(error.response.data);
            }
        }

        isLoading.value = false;
    });
}

function showPasswordIcon() {
    isHidden.value = !isHidden.value;
}

function showPasswordIconCheck() {
    isHiddenCheck.value = !isHiddenCheck.value;
}

function isValidationError(controlName: string): boolean {
    return FormHelper.isControlValidationError(controlName, validationErrors.value);
}

return (_ctx: any,_cache: any) => {
  return (options.value)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        onKeydown: _cache[8] || (_cache[8] = _withKeys(_withModifiers(($event: any) => (submitForm()), ["prevent","stop"]), ["enter"])),
        class: "account mrg",
        "data-mrgt": "40"
      }, [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("fieldset", {
              class: "fieldset mrg",
              "data-mrgt": "20",
              disabled: isLoading.value
            }, [
              _createElementVNode("div", _hoisted_4, [
                (options.value.isUserName)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                      _createElementVNode("div", _hoisted_6, [
                        _createElementVNode("label", _hoisted_7, _toDisplayString(_unref(localizer).get("Account.Common.UserName")), 1),
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          id: "UserName",
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formData.value.userName) = $event)),
                          autocomplete: "username",
                          class: _normalizeClass([{ 'input-validation-error': isValidationError('UserName') }, 'textbox'])
                        }, null, 2), [
                          [
                            _vModelText,
                            formData.value.userName,
                            void 0,
                            { lazy: true }
                          ]
                        ]),
                        _cache[9] || (_cache[9] = _createElementVNode("span", { class: "valid-sign" }, "*", -1))
                      ])
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("label", _hoisted_10, _toDisplayString(_unref(localizer).get("Account.Common.Email")), 1),
                    _withDirectives(_createElementVNode("input", {
                      type: "email",
                      id: "Email",
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formData.value.email) = $event)),
                      autocomplete: "email",
                      class: _normalizeClass([{ 'input-validation-error': isValidationError('Email') }, 'textbox'])
                    }, null, 2), [
                      [
                        _vModelText,
                        formData.value.email,
                        void 0,
                        { lazy: true }
                      ]
                    ]),
                    _cache[10] || (_cache[10] = _createElementVNode("span", { class: "valid-sign" }, "*", -1))
                  ])
                ]),
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("div", _hoisted_12, [
                    _createElementVNode("label", _hoisted_13, _toDisplayString(_unref(localizer).get("Account.Common.Password")), 1),
                    _withDirectives(_createElementVNode("input", {
                      type: "password",
                      id: "Password",
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((formData.value.password) = $event)),
                      autocomplete: "off",
                      class: _normalizeClass([{ 'input-validation-error': isValidationError('Password') }, 'textbox'])
                    }, null, 2), [
                      [
                        _vModelText,
                        formData.value.password,
                        void 0,
                        { lazy: true }
                      ]
                    ]),
                    _createElementVNode("button", {
                      class: "show-password",
                      onClick: _cache[3] || (_cache[3] = ($event: any) => (_unref(formHelper).showPassword('Password'), showPasswordIcon()))
                    }, [
                      (isHidden.value)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_14))
                        : (_openBlock(), _createElementBlock("span", _hoisted_15))
                    ]),
                    _cache[11] || (_cache[11] = _createElementVNode("span", { class: "valid-sign" }, "*", -1))
                  ])
                ]),
                (options.value.isPasswordCheck)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                      _createElementVNode("div", _hoisted_17, [
                        _createElementVNode("label", _hoisted_18, _toDisplayString(_unref(localizer).get("Account.Common.PasswordCheck")), 1),
                        _withDirectives(_createElementVNode("input", {
                          type: "password",
                          id: "ConfirmPassword",
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((formData.value.passwordCheck) = $event)),
                          autocomplete: "off",
                          class: _normalizeClass([{ 'input-validation-error': isValidationError('ConfirmPassword') }, 'textbox'])
                        }, null, 2), [
                          [
                            _vModelText,
                            formData.value.passwordCheck,
                            void 0,
                            { lazy: true }
                          ]
                        ]),
                        _createElementVNode("button", {
                          class: "show-password",
                          onClick: _cache[5] || (_cache[5] = ($event: any) => (_unref(formHelper).showPassword('ConfirmPassword'), showPasswordIconCheck()))
                        }, [
                          (isHiddenCheck.value)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_19))
                            : (_openBlock(), _createElementBlock("span", _hoisted_20))
                        ]),
                        _cache[12] || (_cache[12] = _createElementVNode("span", { class: "valid-sign" }, "*", -1))
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ])
            ], 8, _hoisted_3),
            _createElementVNode("fieldset", {
              class: "fieldset",
              disabled: isLoading.value
            }, [
              _createElementVNode("div", _hoisted_22, [
                _createElementVNode("div", _hoisted_23, [
                  _createElementVNode("div", _hoisted_24, [
                    _withDirectives(_createElementVNode("input", {
                      type: "checkbox",
                      id: "IsPrivacyPolicy",
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((formData.value.isPrivacyPolicy) = $event))
                    }, null, 512), [
                      [_vModelCheckbox, formData.value.isPrivacyPolicy]
                    ]),
                    _createElementVNode("label", _hoisted_25, [
                      _createTextVNode(_toDisplayString(_unref(localizer).get("Coupon.Common.PrivacyDisclaimer_Text")) + " ", 1),
                      _createElementVNode("span", _hoisted_26, [
                        _createElementVNode("a", {
                          href: _unref(routes).Terms_PrivacyPolicy,
                          target: "_blank",
                          class: "button-privacy"
                        }, _toDisplayString(_unref(localizer).get("Coupon.Common.PrivacyDisclaimer_Button")), 9, _hoisted_27)
                      ])
                    ])
                  ])
                ])
              ])
            ], 8, _hoisted_21),
            _createElementVNode("fieldset", {
              class: "fieldset",
              disabled: isLoading.value
            }, [
              (validationErrors.value.length !== 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                    _createElementVNode("ul", null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(validationErrors.value, (validationError, index) => {
                        return (_openBlock(), _createElementBlock("li", { key: index }, _toDisplayString(validationError.message), 1))
                      }), 128))
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_30, [
                _createElementVNode("div", _hoisted_31, [
                  _createElementVNode("button", {
                    id: "ButtonSubmit",
                    class: "button",
                    onClick: _cache[7] || (_cache[7] = ($event: any) => (submitForm())),
                    disabled: isLoading.value
                  }, [
                    _createElementVNode("span", _hoisted_33, _toDisplayString(_unref(localizer).get("Account.Common.Button_Next")), 1)
                  ], 8, _hoisted_32)
                ])
              ]),
              _createElementVNode("div", _hoisted_34, [
                _createElementVNode("div", {
                  class: "captcha-terms",
                  innerHTML: _unref(localizer).get('App.Recaptcha.CaptchaTerms')
                }, null, 8, _hoisted_35)
              ])
            ], 8, _hoisted_28)
          ])
        ])
      ], 32))
    : _createCommentVNode("", true)
}
}

})